import { createCardLayoutStyles } from '~/pages/anatomy/quizBinaryChoice/libs/styles/cardLayout'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = createCardLayoutStyles({
  secondBehind: '#ffd387',
  firstBehind: COLORS.PURPLE_100,
  front: '#fdfcf7',
})
